import { Box, styled } from "@mui/material";

export const StyledQuoteData = styled(Box)(({theme}) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    alignItems: "center",
    justifyContent: "center",
".selectProject": {
    width: "60%",
   '& .MuiInputBase-root': {
    width: "100%"
  },
},
".row": {
  display: "flex",
  gap: "5rem",
  ".column": {
    display: "flex",
    flexDirection: "column",
  }
},
".vatOptions": {
    width: "60%",
    display :"flex",
    alignItems: "center",
    gap: "1rem",
    justifyContent: "center",
    "& .MuiToggleButton-root": {
            width: "20rem",
            fontSize: "2rem",
          },
          "& .Mui-selected": {
            backgroundColor: "primary.main",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
},
".submitBtn": {

}
}));